/**
 * The www.tinycms.ai cookie banner's answer, shared with the app (owner,
 * 2026-10-23). That banner names the tinycms app too, and keeps the answer in
 * a cookie for .tinycms.ai (smagent-sites lib/sharedConsent.ts writes it:
 * "granted.v1.1792000000"). Someone who answered there isn't asked again
 * here: the app records the same answer, with where it came from.
 *
 * Any answer carries, yes or no, whichever wording version it was given
 * under (owner: not public yet, only friends and family).
 */
const COOKIE = 'tinycms_consent';

export type CarriedConsent = { consent: boolean; source: string };

export function carriedConsent(cookieHeader: string): CarriedConsent | null {
  const raw = String(cookieHeader || '')
    .split(/;\s*/)
    .find((c) => c.startsWith(`${COOKIE}=`));
  if (!raw) return null;
  const m = /^(granted|denied)\.v(\d{1,3})(?:\.\d+)?$/.exec(raw.slice(COOKIE.length + 1));
  if (!m) return null;
  return { consent: m[1] === 'granted', source: `site_banner_v${m[2]}` };
}
